import HTTP_GESCOM from '../HTTP_GESCOM';

const URL_BASE = 'commun/PieceJointe/';

export async function GetPiecesJointesAsync(elementId) {
  const response = await HTTP_GESCOM.get(URL_BASE + 'GetAllByElementId/?ElementId=' + elementId);
  
  const piecesJointes = response.data.result.items || [];
  const pjLogo = piecesJointes.find((pj) => pj.placeType === 'Logo');
  return { data: pjLogo || {} };
}

export async function createPiecesJointes(fd) {
  const response = await HTTP_GESCOM.post(URL_BASE + 'CreatePiecesJointes', fd);
  return response;
}

export async function GetPJAsync(elementId) {
  const response = await HTTP_GESCOM.get(URL_BASE + 'GetAllByElementId/?ElementId=' + elementId);
  const piecesJointes = response.data.result.items || [];
  return { data: piecesJointes };
}

export async function updatePiecesJointes(fd) {
  const response = await HTTP_GESCOM.put(URL_BASE + 'UpdatePiecesJointes', fd);
  return response;
}

export async function pGetAllPieceJointe(payload) {
  const response = await HTTP_GESCOM.post(URL_BASE + 'PGetAllByElementsIdAsync', payload);
  return response;
}